import { DefaultResponseCodeEnum } from '@workalizer/shared';
export var deleteWorkspace = function (input) {
    return {
        code: DefaultResponseCodeEnum.SUCCESS,
        success: true
    };
};
